module.exports = __webpack_public_path__ + "static/media/FuturaPTHeavy.5dfc35f2.otf";